import React, { Component } from "react";
import { FormLabel } from "@mui/material";
import {
  Alignment,
  Bold,
  ClassicEditor,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  HorizontalLine,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  SourceEditing,
  Table,
  TableToolbar,
  Underline,
  Undo,
} from "ckeditor5";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";

const HTML_SUPPORT_ALLOW = [
  { name: "table", attributes: true, classes: true, styles: true },
  { name: "thead", attributes: true, classes: true, styles: true },
  { name: "tbody", attributes: true, classes: true, styles: true },
  { name: "tr", attributes: true, classes: true, styles: true },
  { name: "td", attributes: true, classes: true, styles: true },
  { name: "th", attributes: true, classes: true, styles: true },
  { name: "span", attributes: true, classes: true, styles: true },
  { name: "p", attributes: true, classes: true, styles: true },
  { name: "div", attributes: true, classes: true, styles: true },
  { name: "h1", attributes: true, classes: true, styles: true },
  { name: "h2", attributes: true, classes: true, styles: true },
  { name: "h3", attributes: true, classes: true, styles: true },
  { name: "h4", attributes: true, classes: true, styles: true },
  { name: "h5", attributes: true, classes: true, styles: true },
  { name: "h6", attributes: true, classes: true, styles: true },
  { name: "strong", attributes: true, classes: true, styles: true },
  { name: "em", attributes: true, classes: true, styles: true },
  { name: "a", attributes: true, classes: true, styles: true },
  { name: "img", attributes: true, classes: true, styles: true },
  { name: "ul", attributes: true, classes: true, styles: true },
  { name: "ol", attributes: true, classes: true, styles: true },
  { name: "li", attributes: true, classes: true, styles: true },
  { name: "blockquote", attributes: true, classes: true, styles: true },
  { name: "hr", attributes: true, classes: true, styles: true },
  { name: "br", attributes: true, classes: true, styles: true },
];

class FormEditors extends Component {
  constructor(props) {
    super(props);
    this.editor = null;
    this.isSettingData = false;
  }

  componentDidUpdate(prevProps) {
    if (!this.editor || this.props.value === prevProps.value) {
      return;
    }

    const current = this.editor.getData();
    if (this.props.value !== current) {
      this.isSettingData = true;
      this.editor.setData(this.props.value || "");
      this.isSettingData = false;
    }
  }

  render() {
    return (
      <React.Fragment>
        <FormLabel style={{ fontFamily: "Manrope-SemiBold", fontSize: 14 }}>
          {this.props?.title}
        </FormLabel>
        <CKEditor
          editor={ClassicEditor}
          data={this.props?.value || ""}
          onReady={(editor) => {
            this.editor = editor;
          }}
          onChange={(event, editor) => {
            if (this.isSettingData) {
              return;
            }
            this.props?.setValue(editor.getData());
          }}
          config={{
            toolbar: {
              items: [
                "heading",
                "|",
                "fontFamily",
                "bold",
                "italic",
                "underline",
                "fontSize",
                "fontColor",
                "fontBackgroundColor",
                "bulletedList",
                "numberedList",
                "alignment",
                "link",
                "insertTable",
                "horizontalLine",
                "undo",
                "redo",
                "|",
                "sourceEditing",
              ],
            },
            heading: {
              options: [
                { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
                { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
                { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
              ],
            },
            htmlSupport: {
              allow: HTML_SUPPORT_ALLOW,
            },
            table: {
              contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
            },
            placeholder: this.props?.placeholder || "",
            plugins: [
              Bold,
              Essentials,
              Italic,
              Mention,
              Paragraph,
              Undo,
              FontFamily,
              FontSize,
              FontColor,
              FontBackgroundColor,
              Underline,
              List,
              Alignment,
              HorizontalLine,
              Link,
              Heading,
              GeneralHtmlSupport,
              SourceEditing,
              Table,
              TableToolbar,
            ],
          }}
        />
      </React.Fragment>
    );
  }
}

export default FormEditors;
